<template>
    <div class="row" :data-expand="isExpand ? true : null">
        <div class="cells" v-on:click="toggleExpand()">
            <span class="cell" data-size="status" data-align="center">
                <span class="icon-status" :data-icon="histItem.userNm == 'System' ? 'system' : 'user'" :title="histItem.userNm == 'System' ? 'System' : 'User'">System</span>
            </span>
            <span class="cell" data-size="date">
                <time datetime="">{{convertUtcTimezoneToLocal(histItem.timeLine)}}</time>
            </span>
            <span class="cell" data-size="type">
                {{ $t('AUDIT.FILTER.POLICY')}}<!--정책-->
            </span>
            <span class="cell" data-size="user">
                {{histItem.userNm}}
            </span>
            <span class="cell">
                {{histItem.histType == constants.HIST_TYPE.POLICY_CREATE ? $t('AUDIT.LABEL.CASE.CREATE')
                : histItem.histType =='policyDelete' ? $t('AUDIT.LABEL.CASE.DELETE')
                : histItem.histType =='policyCopy' ? $t('AUDIT.LABEL.CASE.COPY'):''}}&nbsp;:&nbsp;<a href="#">{{histItem.prgrSetNm}}</a>
            </span>
            <span class="cell" data-align="center">
                <button type="button" class="buttons-icon" data-type="ghost" data-icon="expand" :data-expand="isExpand ? true : null">collapse / expand</button>
            </span>
        </div>

        <div class="expand-container">
            <div-loading v-if="isExpand && plcyInfo == null"></div-loading>
            <!-- inner tables -->
            <table class="tbl-inner" v-if="plcyInfo !== null">
                <caption>{{ $t('AUDIT.LABEL.CASE.CREATE_COPY_DELETE_POLICY')}}</caption>
                <colgroup>
                    <col style="width: 185px;">
                </colgroup>
                <thead>
                <tr>
                    <th scope="col">{{ $t('AUDIT.LABEL.HEADER.ITEM')}}<!--항목--></th>
                    <th scope="col">{{ $t('AUDIT.LABEL.HEADER.DETAIL_CONTENTS')}}<!--상세 내용--></th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <th>{{ $t('AUDIT.POLICY.NAME')}}<!--이름--></th>
                    <td>{{plcyInfo.plcyTitl}}</td>
                </tr>
                <tr>
                    <th>{{ $t('AUDIT.POLICY.DESCRIPTION')}}<!--설명--></th>
                    <td>{{plcyInfo.plcyDesc}}</td>
                </tr>
                <tr>
                    <th>{{ $t('AUDIT.POLICY.APPLIED_RULES')}}<!--적용된 규칙--></th>
                    <td>
                        <span v-for="rule of arrRuleInfo" class="item">{{rule.ruleTitl}}</span>
                    </td>
                </tr>
                </tbody>
            </table>

        </div>
    </div>

</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: 'expandPolicyCreate',
        props: ['histItem'],
        data: function() {
          return {
              plcyInfo: null,
              arrRuleInfo: null,
              isExpand: false
          }
        },
        computed: {
            ...mapGetters({
                curCmpnId: 'user/curCmpnId'
            }),
            getLocale: function() {
                return this.$i18n.locale
            }
        },
        methods: {
            selectGovernancePolicyInfo() {

                const url = `/api/governance/audit/expand/policy/info`

                let ruleData = {
                    'cmpnId': this.curCmpnId,
                    'rvsnId': this.histItem.afRvsnId
                }
                this.http.post(url, ruleData)
                    .then((result) => {
                        if(result.data.status == 'ok') {

                            let arrPlcyInfo = result.data.result

                            this.plcyInfo = arrPlcyInfo !== null && arrPlcyInfo.length > 0 ? _.union(arrPlcyInfo, 'plcyTitl')[0] : null
                            this.arrRuleInfo = arrPlcyInfo
                        } else {
                            // TODO :: Error 처리
                        }
                    }).catch(error => {
                    // TODO :: Error 처리
                });
            },
            convertUtcTimezoneToLocal: function(date) {
                return date == null ? '-' : this.Common.convertUtcTimezoneToLocalByLang(date, this.getLocale)
            },
            toggleExpand: function(){
                this.isExpand = !this.isExpand
                this.isExpand && this.plcyInfo == null ? this.selectGovernancePolicyInfo() : false

            }
        }

    }
</script>



// WEBPACK FOOTER //
// src/components/audit/expand/policyCreate.vue